<template>
    <div
        :class="{
            'border-grey-500 border': isInput,
        }"
    >
        <div class="bg-white flex justify-between col-span-7">
            <div
                class="flex items-center justify-between w-full h-10"
                :class="{
                    'border-grey-500 border-b': isInput && isControll == false,
                }"
            >
                <!-- 'pt-2': isControll, -->
                <!-- px-3 -->

                <button
                    class="flex items-center"
                    @click="isControll ? (selectview = 'year') : null"
                    type="button"
                    :class="{ 'cursor-default': !isControll }"
                >
                    <p
                        class="text-15 font-semibold pr-3"
                        @click.stop="$emit('titleClicked')"
                        :class="[
                            {
                                'pl-0': isControll,
                            },
                            [setEventsByDay ? 'text-grey-900' : 'text-black hover:cursor-pointer hover:opacity-70'],
                        ]"
                    >
                        {{ selectview != null ? 'Select ' + selectview : calendarTitle }}
                    </p>
                    <IconArrowDown class="stroke-grey-900 w-4 h-4" v-if="isControll && selectview == null" />

                    <button
                        type="button"
                        v-if="(isInput || isControll) && selectview != null"
                        class="icon-hover"
                        @click.stop="selectview = null"
                    >
                        <IconClose class="h-4.5 w-4.5" />
                    </button>
                </button>

                <div class="flex items-center -mr-1" v-if="isInput || isControll">
                    <button
                        @click="selectview == null ? calendarBack() : selectViewBack()"
                        type="button"
                        class="h-10 flex items-center justify-center stroke-black hover:stroke-grey-800 disabled:stroke-grey-800"
                        :class="[!isControll ? 'border-l border-grey-500 w-10' : 'mr-2']"
                        :disabled="selectview == 'month'"
                    >
                        <IconArrowLeft class="h-4.5 w-4.5 pointer-events-none" />
                    </button>

                    <button
                        @click="selectview ==await ? calendarForward() : selectViewForward()"
                        type="button"
                        class="h-10 flex items-center justify-center stroke-black hover:stroke-grey-800 disabled:stroke-grey-800"
                        :class="[!isControll ? 'border-l border-grey-500 w-10' : '']"
                        :disabled="selectview == 'month'"
                    >
                        <IconArrowRight class="h-4.5 w-4.5 pointer-events-none" />
                    </button>
                </div>
            </div>
        </div>

        <div class="relative">
            <div class="absolute inset-0 bg-white z-10" v-if="selectview != null">
                <div
                    class="grid grid-cols-3 h-full content-around"
                    :class="{
                        ' mt-3 px-2 ': !isControll,
                    }"
                    v-if="selectview == 'year'"
                >
                    <button
                        class="h-8 text-grey-900 text-14"
                        type="button"
                        @click="
                            () => {
                                selectview = 'month'
                                month = $moment(month, format).subtract(8, 'Year').add(y, 'Year').startOf('month')
                            }
                        "
                        :class="{
                            'bg-black text-white rounded-tl-[8px] rounded-br-[8px]':
                                $moment(month, format).subtract(8, 'Year').add(y, 'Year').format('YYYY') == $moment().format('YYYY'),
                        }"
                        v-for="y in 12"
                    >
                        {{ $moment(month, format).subtract(8, 'year').add(y, 'year').format('YYYY') }}
                    </button>
                </div>

                <div
                    class="grid grid-cols-3 h-full items-center content-around"
                    :class="{
                        ' mt-3 px-2 ': !isControll,
                    }"
                    v-if="selectview == 'month'"
                >
                    <button
                        class="h-8 text-grey-900 text-14"
                        type="button"
                        @click="
                            () => {
                                selectview = null
                                calendarSetDate(
                                    $moment(month, format)
                                        .set('month', y - 1)
                                        .startOf('month'),
                                )
                            }
                        "
                        :class="{
                            'bg-black text-white rounded-tl-[8px] rounded-br-[8px]':
                                $moment(month, format)
                                    .startOf('year')
                                    .add(y - 1, 'Month')
                                    .format('MMMM YYYY') == $moment().format('MMMM YYYY'),
                        }"
                        v-for="y in 12"
                    >
                        {{
                            $moment(month, format)
                                .startOf('year')
                                .add(y - 1, 'Month')
                                .format('MMMM')
                        }}
                    </button>
                </div>
            </div>

            <div
                class="grid grid-cols-7 text-14 gap-y-1 py-2 transition-all duration-300 ease-in-out relative"
                :class="[
                    marginClass,
                    {
                        'gap-x-[15px]': isControll,
                    },
                ]"
            >
                <template v-for="(title, ti) in titlesWeekDays">
                    <div class="bg-white">
                        <p class="text-grey-800 text-12 lg:text-14 text-center h-8 lg:leading-[32px]" v-text="title[0]" />
                    </div>
                </template>

                <div
                    v-for="(day, di) in calendar"
                    class="h-8 text-center text-13 leading-[32px] flex items-center justify-center relative"
                    :class="{
                        'bg-grey-300/50 text-black': day.date.isAfter(this.value.starts) && day.date.isBefore(this.value.ends),
                        '!text-grey-800': day.notInMonth || day.date.isBefore($moment()),
                    }"
                    @click="click(day)"
                    @mouseover="mouseover(day)"
                    @mouseleave="mouseleave(day)"
                >
                    <div
                        v-if="day.date.isSame(this.value.starts) || day.date.isSame(this.value.ends)"
                        class="absolute top-0 bottom-0 bg-grey-300/50"
                        :class="{
                            'left-[50%] right-0': day.date.isSame(this.value.starts),
                            'right-[50%] left-0': day.date.isSame(this.value.ends),
                        }"
                    />

                    <!-- @click="$emit('click', day)" -->
                    <div
                        class="h-full w-8 z-10 cursor-pointer hover:text-white hover:bg-black transition-all duration-200 ease-in-out"
                        :class="{
                            'bg-black text-white': day.date.isSame(this.value.starts) || day.date.isSame(this.value.ends),
                            'bg-black text-white rounded-full':
                                day.isToday && !day.notInMonth && !(day.date.isSame(this.value.starts) || day.date.isSame(this.value.ends)),
                        }"
                    >
                        {{ day.date.format('D') }}

                        <div class="flex items-center justify-center gap-x-1 -mt-1.5">
                            <div
                                class="w-1 h-1 bg-purple-600 rounded-full"
                                v-if="day.yearEvents != null && parseInt(day.yearEvents.tasks) > 0"
                            />

                            <div
                                class="w-1 h-1 bg-blue-600 rounded-full"
                                v-if="day.yearEvents != null && parseInt(day.yearEvents.appointments) > 0"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Calendar from '~/mixins/calendar.js'

export default {
    mixins: [Calendar],

    props: {
        startsAt: { type: Object, deafult: null },
        endsAt: { type: Object, deafult: null },
        isInput: { type: Boolean, default: true },
        isControll: { type: Boolean, default: false },
        loadDate: { type: Object, deafult: null },
        events: { type: Array, default: [] },
        marginClass: { type: [String, Object], default: null },
    },

    data() {
        return {
            view: 'month',
            selectview: null,
            hasPage: false,
            selecting: false,
            monthRows: 6,
            month: this.$moment().format(),
            value: {
                starts: this.startsAt,
                ends: this.endsAt,
            },
            setEventsByDay: false,
            showYearOnMonthView: true,
        }
    },

    mounted() {
        // console.log(this.events)
        this._createCalendar()
    },

    methods: {
        click(day) {
            // console.log('clicking', day)
            if (!this.isInput) {
                this.$emit('onClick', day)
                this.value.starts = day.date
                return
            }

            // console.log('clicked')

            if (this.selecting == false) {
                console.log('selecting')
                this.selecting = true
                this.value.starts = day.date
                this.value.ends = null
            } else {
                // console.log('not selecting')
                this.selecting = false
                this.value.ends = day.date
                this.$emit('updated', [this.value.starts.format('YYYY-MM-DD'), this.value.ends.format('YYYY-MM-DD')])
            }
        },

        mouseover(day) {
            if (this.selecting) {
                this.value.ends = day.date
            }
        },

        mouseleave(day) {
            if (this.selecting) {
                this.value.ends = null
            }
        },

        selectViewBack() {
            this.month = this.$moment(this.month).subtract(3, 'year').format()
        },

        selectViewForward() {
            this.month = this.$moment(this.month).add(3, 'year').format()
        },
    },

    watch: {
        loadDate() {
            if (!this.hasPage) {
                if (this.loadDate != null) {
                    this.localDate = this.loadDate.format('YYYY-MM-DD')
                }

                this._createCalendar()
            }
        },
    },
}
</script>
